import { render } from "./MetaSettings.vue?vue&type=template&id=c7b261ec&scoped=true"
import script from "./MetaSettings.vue?vue&type=script&lang=js"
export * from "./MetaSettings.vue?vue&type=script&lang=js"

import "./MetaSettings.vue?vue&type=style&index=0&id=c7b261ec&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7b261ec"]])

export default __exports__